const errorLog = {
  namespaced: true,
  state: {
    logs: [],
    fatalError: false,
  },
  mutations: {
    ADD_ERROR_LOG: (state, log) => {
      state.logs.push(log)
    },
    FATAL_ERROR: (state) => {
      state.fatalError = true
    },
  },
  actions: {
    addErrorLog({ commit }, log) {
      commit('ADD_ERROR_LOG', log)
    }
  }
}

export default errorLog
